// vim: set ts=2 sts=2 sw=2 et:
//
// This file is part of OpenLifter, simple Powerlifting meet software.
// Copyright (C) 2026 The OpenPowerlifting Project.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as
// published by the Free Software Foundation, either version 3 of the
// License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.

import { Entry } from "../../types/dataTypes";

export const REGISTRATION_PAGE_SIZE = 25;

export type PaginatedRegistrations = {
  page: number;
  totalPages: number;
  entries: Entry[];
};

/**
 * Select one page from an already ordered collection of registration Entries.
 * The requested page is zero-based and is clamped so callers never render an
 * empty out-of-range page after the collection changes.
 */
export const paginateEntries = (entries: ReadonlyArray<Entry>, requestedPage: number): PaginatedRegistrations => {
  const totalPages = Math.ceil(entries.length / REGISTRATION_PAGE_SIZE);
  const normalizedPage = Number.isFinite(requestedPage) ? Math.floor(requestedPage) : 0;
  const page = totalPages === 0 ? 0 : Math.min(Math.max(normalizedPage, 0), totalPages - 1);
  const start = page * REGISTRATION_PAGE_SIZE;

  return {
    page,
    totalPages,
    entries: entries.slice(start, start + REGISTRATION_PAGE_SIZE),
  };
};
